import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 9h4v11h-4zm-6-5h4v16h-4zm-6 8h4v8H4z"
}), 'EqualizerTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/EqualizerTwoTone.js
// module id = 3382
// module chunks = 2